// import React, { useEffect } from 'react'
import Navbar from '../components/Navbar'
import Carousel from '../components/Carousel'
import axios from 'axios';
import './Home.css';
import Cards from '../components/Cards';
import Navbar2 from '../components/Navbar2';
import BestBrandsOnOffer from '../components/BBOO/BestBrandsOnOffer';
import TheWestsideStore from '../components/TWS/TheWestsideStore';
import { Link } from 'react-router-dom';
import IndianWomenWear from '../components/IWW/IndianWomenWear';
import IndianMensWear from '../components/IMW/IndianMensWear';
import NextGenFashion from '../components/NGF/NextGenFashion';
import HomeChecklist from '../components/Home Checklist/HomeChecklist';
import TheDigiDen from '../components/Digi Den/TheDigiDen';
import WatchThisSpace from '../components/Watch/WatchThisSpace';
import FullyFramed from '../components/Fully Framed/FullyFramed';
import ShineOn from '../components/shine on/ShineOn';
import Footer from '../components/Footer/Footer';
import { LazyLoadImage } from 'react-lazy-load-image-component';
import 'react-lazy-load-image-component/src/effects/blur.css';

function Home() {
  axios.defaults.withCredentials = true;
  // useEffect(() => {
  //   axios.get('http://localhost:3001/home')
  //   .then(result => {
  //     console.log(`Home result: ${result}`);
  //     // if(result.data !== "Success") {
  //     //   console.log("Not authenticated, showing login modal...");
  //     //   window.dispatchEvent(new CustomEvent("showLoginModal"));
  //     // }
  //   })
  //   .catch(err => {
  //     console.log(`Home error ${err}`);
  //     window.dispatchEvent(new CustomEvent("showLoginModal"));
  //   })
  // }, []);


  return (
    <div className='home-container'>
        <Navbar/>
        <div className="sticky-navbar">
        <Navbar2 />
        </div>
        <div className='home-banner'>
          <LazyLoadImage
          src="https://assets.tatacliq.com/medias/sys_master/images/64684325437470.jpg" 
          alt="Tata CLiQ Banner" 
          className='banner-image'
          effect="blur"
            // width="100%"
            height="auto"
          />
          {/* <img 
          src="https://assets.tatacliq.com/medias/sys_master/images/64684325437470.jpg" 
          alt="Tata CLiQ Banner" 
          className='banner-image'
          />   */}
        </div>
        <div className="carousal-container">
        <Carousel/>
        </div>

        <div className="cards-section">
          <Cards/>
        </div>

        <div className="add-row">
          <div className="column">
            <LazyLoadImage
            src="https://assets.tatacliq.com/medias/sys_master/images/64684496584734.jpg" 
            alt="icici"
            effect="blur"
            />
            {/* <img src="https://assets.tatacliq.com/medias/sys_master/images/64684496584734.jpg" alt="icici" /> */}
          </div>
          <div className="column">
            <LazyLoadImage
            src="https://assets.tatacliq.com/medias/sys_master/images/62309792808990.jpg" 
            alt="paytm"
            effect="blur"
            />
            {/* <img src="https://assets.tatacliq.com/medias/sys_master/images/62309792808990.jpg" alt="paytm" /> */}
          </div>
        </div>

        <div className="bbof ">
          <div className="bbof-header text-center">
          <h2>Best Brands On Offer</h2>
          </div>
          <BestBrandsOnOffer/>
        </div>

        <div className="car-adv">
          <LazyLoadImage
          src="https://assets.tatacliq.com/medias/sys_master/images/64829260726302.jpg" 
          alt="car adv"
          effect="blur"
          />
          {/* <img src="https://assets.tatacliq.com/medias/sys_master/images/64829260726302.jpg" alt="car adv" /> */}
        </div>

        <div className="TWSS">
          <div className="TWSS-header text-center mt-5">
            <h2>The Westside Store</h2>
          </div>
          <TheWestsideStore/>
        </div>

        <div className="ind-reima">
          <div className="ind-reima-header text-center mt-2 mb-5">
            <h2>Indianwear Reimagined</h2>
          </div>
          <Link>
          <img src="https://assets.tatacliq.com/medias/sys_master/images/63588842831902.png" alt="Indianwear Reimagined" 
          style={{height:"300px", width: "100%", paddingLeft:"30px", paddingRight:"30px"}}
          />
          </Link>
        </div>

        <div className="ind-women-wear">
          <IndianWomenWear/>
        </div>

        <div className="hot-boy-fit">
          <div className="hot-boy-fit-header text-center mt-2 mb-5">
            <h2>Hot Boy Fits</h2>
          </div>
          <Link>
          <img src="https://assets.tatacliq.com/medias/sys_master/images/63588844339230.png" alt="Indianwear Reimagined" 
          style={{height:"300px", width: "100%", paddingLeft:"30px", paddingRight:"30px"}}
          />
          </Link>
        </div>

        <div className="ind-mens-wear">
          <IndianMensWear/>
        </div>

        <div className="ngf">
          <div className="ngf-header text-center mt-2 mb-5">
          <h2>Next-Gen Fits</h2>
          </div>
          <NextGenFashion/>
        </div>

        <div className="home-checklist text-center mt-2 mb-5">
          <div className="home-checklist-header">
            <h2>Home Checklist</h2>
          </div>
          <HomeChecklist/>
        </div>

        <div className="digi-den text-center mt-2 mb-5">
          <div className="digi-den-header">
            <h2>Home Checklist</h2>
          </div>
          <TheDigiDen/>
        </div>

        <div className="watch-space text-center mt-2 mb-5">
          <div className="watch-space-header">
            <h2>Watch This Space</h2>
          </div>
          <WatchThisSpace/>
        </div>

        <div className="fully-framed text-center mt-2 mb-5">
          <div className="fully-framed-header">
            <h2>Fully Framed</h2>
          </div>
          <FullyFramed/>
        </div>

        <div className="shine-on text-center mt-2 mb-5">
          <div className="shine-on-header">
            <h2>Shine On</h2>
          </div>
          <ShineOn/>
        </div>

        <div className="stay-safe">
          <Link>
          <img src="https://assets.tatacliq.com/medias/sys_master/images/49733188190238.jpg" alt="Stay safe" 
          style={{height:"300px", width: "100%", paddingLeft:"30px", paddingRight:"30px"}}
          />
          </Link>
        </div>
        <Footer/>
    </div>
  )
}

export default Home